// extracted by mini-css-extract-plugin
export var footer = "_pi-5";
export var fulfillmentInput = "_pi-0";
export var shipDateInput = "_pi-1";
export var shipmentModal = "_pi-2";
export var shipmentModalContent = "_pi-3";
export var tableContainer = "_pi-4";